import React, { useState } from 'react';

const RoleContext = React.createContext(localStorage.getItem('role'));

const RoleContextProvider = ({ children }) => {
    const changeRoleGlobalState = (value) => changeIsAdmin(value);
    const [isAdmin, changeIsAdmin] = useState(localStorage.getItem('role'));

    return (
        <RoleContext.Provider value={{ isAdmin, changeRoleGlobalState }}>
            {children}
        </RoleContext.Provider>
    );
}

const RoleContextConsumer = RoleContext.Consumer;

export { RoleContextProvider, RoleContextConsumer, RoleContext };